import { Modal, useModals } from 'almanac-ui/Modal'
import { DesignChannel } from 'components/NewFileModal/Types'
import { TikTokPostSettings } from 'components/PostPreviewModal/components/TikTokPostSettings'
import { YoutubePostDetails } from 'components/PostPreviewModal/components/Youtube/YoutubePostDetails'
import { useScheduledPost } from 'hooks/queries/scheduledPosts/useScheduledPost'
import { useScheduledPostTarget } from 'hooks/queries/scheduledPostTargets/useScheduledPostTarget'

interface PostSettingsModalProps {
  channel: DesignChannel
  scheduledPostId: number
  scheduledPostTargetId?: number
}

const platformConfig = {
  [DesignChannel.TikTokPost]: {
    title: 'TikTok Privacy & Interaction Controls',
    channel: DesignChannel.TikTokPost,
    component: TikTokPostSettings,
    additionalProps: { isModal: true },
  },
  [DesignChannel.YoutubeShort]: {
    title: 'YouTube Post Settings',
    channel: DesignChannel.YoutubeShort,
    component: YoutubePostDetails,
    additionalProps: {},
  },
}

export const PostSettingsModal = ({ channel, scheduledPostId, scheduledPostTargetId }: PostSettingsModalProps) => {
  const { closeModal } = useModals()

  const isPerTargetSettings = scheduledPostTargetId !== undefined

  const { data: scheduledPost, isLoading: isLoadingPost } = useScheduledPost({
    id: scheduledPostId,
  })

  const { data: scheduledPostTarget, isLoading: isLoadingTarget } = useScheduledPostTarget(
    scheduledPostId,
    scheduledPostTargetId as number,
    { enabled: isPerTargetSettings },
  )

  const isLoading = isPerTargetSettings ? isLoadingTarget : isLoadingPost

  if (isLoading) return null

  const config = platformConfig[channel as keyof typeof platformConfig]
  const Component = config.component

  return (
    <Modal.Root size="sm">
      <Modal.Header title={config.title} />
      <Modal.Content>
        <Component
          scheduledPost={scheduledPost as any}
          scheduledPostTarget={scheduledPostTarget}
          channel={config.channel}
          {...config.additionalProps}
        />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" onPress={closeModal}>
            Save
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
